import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import ApiService from "../../services/apiService";
import Loader from "../../elements/Loader";

const AccessControl = () => {
  const [rolesPrivileges, setRolesPrivileges] = useState([]);
  const [editedPrivileges, setEditedPrivileges] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(()=> {
    getRoleAccess();
  }, []);

  const getRoleAccess = async () => {
    // Fetch roles and privileges data
    setLoading(true)
    ApiService.get('/role-access')
      .then(response => {
        setRolesPrivileges(response.data);

        // Initialize editedPrivileges with current data
        const initialPrivileges = {};
        response.data.forEach(item => {
          initialPrivileges[item.id] = {
            read: item.read,
            write: item.write,
            delete: item.delete,
          };
        });
        setEditedPrivileges(initialPrivileges);
        setLoading(false)
      })
      .catch(error => console.error(error));
  }

  const handleCheckboxChange = (id, field) => {
    setEditedPrivileges(prevPrivileges => ({
      ...prevPrivileges,
      [id]: {
        ...prevPrivileges[id],
        [field]: !prevPrivileges[id][field],
      },
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true)
      await Promise.all(
        Object.entries(editedPrivileges).map(([id, updatedFields]) =>
          ApiService.put('/role-access', { id, ...updatedFields })
        )
      );
      setLoading(false)
      toast.success("Privileges updated successfully!");
      setEditedPrivileges({});
      getRoleAccess();
    } catch (error) {
      toast.success("Failed to update privileges.");
    }
  };

  return (
    <>
    {loading && <Loader />}
    <div className="text-black p-6 rounded-lg">
      <h2 className="text-2xl font-semibold mb-4">Role Privilege Management</h2>
      <table className="w-full border border-gray-700">
        <thead>
          <tr>
            <th className="p-4 border border-gray-700">Role</th>
            <th className="p-4 border border-gray-700">Privilege</th>
            <th className="p-4 border border-gray-700">Read</th>
            {/* <th className="p-4 border border-gray-700">Write</th>
            <th className="p-4 border border-gray-700">Delete</th> */}
          </tr>
        </thead>
        <tbody>
          {rolesPrivileges.map((item) => (
            <tr key={item.id}>
              <td className="p-4 border border-gray-700">{item.role}</td>
              <td className="p-4 border border-gray-700">{item.privilege}</td>
              <td className="p-4 border border-gray-700">
                <input
                  type="checkbox"
                  checked={editedPrivileges[item.id]?.read ?? item.read}
                  onChange={() => handleCheckboxChange(item.id, 'read')}
                  className="form-checkbox"
                />
              </td>
              {/* <td className="p-4 border border-gray-700">
                <input
                  type="checkbox"
                  checked={editedPrivileges[item.id]?.write ?? item.write}
                  onChange={() => handleCheckboxChange(item.id, 'write')}
                  className="form-checkbox"
                />
              </td>
              <td className="p-4 border border-gray-700">
                <input
                  type="checkbox"
                  checked={editedPrivileges[item.id]?.delete ?? item.delete}
                  onChange={() => handleCheckboxChange(item.id, 'delete')}
                  className="form-checkbox"
                />
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
      <button
        className="bg-blue-600 hover:bg-blue-700 btn btn-primary py-2 px-4 rounded mt-4"
        onClick={handleSave}
      >
        Save Changes
      </button>
    </div>
    </>
  );
};

export default AccessControl;
